module.exports = __webpack_public_path__ + "static/img/index-carousel-05-01.c1e61bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-carousel-05-01.png
// module id = 5bH1
// module chunks = 0